import URI from 'urijs';

const adsBulkAPIPrefix = accountId => `/${accountId}/ads/bulk`;
const adsAPIPrefix = accountId => `/${accountId}/ads`;
const assignCreativesGetListAPIPrefix = accountId => `/${accountId}/reports/creatives/by_account`;

export const assignCreativesApiFactory = ({ callGetApi, callPostApi, callPatchApi, callDeleteApi }) => ({
    getAds: (accountId, campaignId) => {
        return callGetApi(`${adsAPIPrefix(accountId)}/${campaignId}/getAds`);
    },

    createAds: (accountId, ads) => {
        return callPostApi(`${adsBulkAPIPrefix(accountId)}/create`, ads);
    },

    editAds: (accountId, ads) => {
        return callPatchApi(`${adsAPIPrefix(accountId)}`, ads);
    },

    updateAd: (accountId, adId, ad) => {
        return callPostApi(`${adsAPIPrefix(accountId)}/${adId}`, ad);
    },

    removeAd: (accountId, adId) => {
        return callDeleteApi(`${adsAPIPrefix(accountId)}/${adId}`);
    },

    getCreativesByAccount: (accountId, params) => {
        const baseUrl = assignCreativesGetListAPIPrefix(accountId);
        const url = URI(baseUrl).addSearch(params).toString();

        return callGetApi(url);
    },
});
